import { useState } from "react";

export default function InfoBlock({children, title, color, isToggled, onToggle, onCollapse, className, id}) {
    const [section, setSection] = useState(0);

    function updateSection(sectionNumber) {
        if (sectionNumber >= children.length)
            sectionNumber = 0;

        setSection(sectionNumber);
    }

    return (
        <article id={id} className={`block block--${color} ${isToggled ? "block--toggled" : ''} animation animation--from-small ${className}`} onClick={onToggle}>
            <h2 className="block__title">
                {title}
                <div className="block__title-underline" />
            </h2>

            {isToggled && <button className="block__collapse" onClick={onCollapse}><i className="fas fa-compress" /></button>}

            {isToggled && <>
                <section className={`block__content ${Array.isArray(children) ? "block__content--extra-margin" :""}`}>
                    {!Array.isArray(children) && children}

                    {Array.isArray(children) && <>
                        {children[section]}

                        <button className={`block__pagination-button ${children.length === section + 1 ? "block__pagination-button--back" : ""}`} onClick={() => updateSection(section + 1)}>
                            <i className="fas fa-arrow-right" />
                        </button>

                        <div className="block__pagination">
                            {children.map((_, i) => <div className={`block__pagination-section ${section === i ? "block__pagination-section--active" : ""}`} />)}
                        </div>
                    </>}
                </section>
            </>}
        </article>
    )
}
